export const SSO_COPY = {
	COMPANY_DOMAIN: 'Company domain',
	COMPANY_DOMAIN_REQUIRED: 'Company domain is required',
	SSO_HEADER: 'Sign in with SSO',
	SSO_REDIRECT_HELPER: 'You\'ll be taken to ',
	SSO_SUBTEXT: 'Enter your company\'s Arovy domain to continue to your identity provider.'
};
